import { render, staticRenderFns } from "./CustomerResponse.vue?vue&type=template&id=1c4606cc&scoped=true&"
import script from "./CustomerResponse.vue?vue&type=script&lang=js&"
export * from "./CustomerResponse.vue?vue&type=script&lang=js&"
import style0 from "./CustomerResponse.vue?vue&type=style&index=0&id=1c4606cc&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1c4606cc",
  null
  
)

export default component.exports